import { gsap } from "gsap";

jQuery(($) => {


    function disableSection(section) {
        section.querySelector('input,select,textarea').removeAttribute('required');
        section.classList.add('multisection-fw-form__step--disabled');
    }

    function enableSection(section) {
        section.querySelector('input,select,textarea').setAttribute('required', 'required');
        section.classList.remove('multisection-fw-form__step--disabled');
    }

    const container = document.querySelector('.js-contact-form');

    if (container) {
        const contactForm = container.querySelector('#hireUsForm');
        if (contactForm) {

            contactForm.querySelectorAll('input').forEach((el) =>
                el.addEventListener('keydown', (event) => {
                    if (event.keyCode === 13) {
                        event.preventDefault();
                        gotoNext(event);
                    }
                })
            );

            let fetchByStep = (step) => contactForm.querySelector('.multisection-fw-form__step[data-step="'+step+'"]:not(.multisection-fw-form__step--disabled)');

            let sections = contactForm.querySelectorAll('.multisection-fw-form__step:not(.multisection-fw-form__step--disabled)');
            let firstStep = parseInt(sections.item(0).dataset.step);
            let lastStep = parseInt(sections.item(sections.length-1).dataset.step);

            let resetSection = () => {
                sections = contactForm.querySelectorAll('.multisection-fw-form__step:not(.multisection-fw-form__step--disabled)');
                firstStep = parseInt(sections.item(0).dataset.step);
                lastStep = parseInt(sections.item(sections.length-1).dataset.step);
            }

            const prevBtn = container.querySelector('#hire-us_go-prev');
            const nextBtn = container.querySelector('#hire-us_go-next');
            const submitBtn = container.querySelector('#hire-us_submit');
            const websiteInput = contactForm.querySelector('.js-website-field');
            const noWebsiteInput = contactForm.querySelector('.js-no-website-field');
            const contactOptionsInputs = contactForm.querySelectorAll('.js-contact-options');
            const contactAvailabilityInputs = contactForm.querySelectorAll('.js-contact-availability');
            const phoneSection = contactForm.querySelector('.js-phone-section');
            const emailSection = contactForm.querySelector('.js-email-section');

            let currentSectionStep = firstStep;

            function showSection(step) {

                prevBtn.setAttribute('aria-busy', 'true');
                nextBtn.setAttribute('aria-busy', 'true');

                /* Hide the current section and display the new active one */
                let currSection = contactForm.querySelector('.multisection-fw-form__step--active');
                console.log(currSection);
                let newSection = fetchByStep(step);

                const tl = gsap.timeline({
                    onComplete: () => {
                        if (currSection)
                            currSection.classList.remove('multisection-fw-form__step--active');
                        newSection.classList.add('multisection-fw-form__step--active');
                        prevBtn.removeAttribute('aria-busy');
                        nextBtn.removeAttribute('aria-busy');
                        const firstFocusable = newSection.querySelector('input, select, button');
                        if (firstFocusable) {
                            firstFocusable.focus();
                        } else {
                            nextBtn.focus();
                        }
                    }
                });

                gsap.set(newSection, {y: '+=100', opacity: 0});

                if (currSection) {
                    tl
                        .to(currSection, {
                        y: '+=100', duration: 0.35, ease: 'power2.inOut', onComplete: () => {
                            gsap.set(currSection, {clearProps: 'all'}); // Clear all inline styles
                            if (currSection)
                                currSection.hidden = true;
                            newSection.hidden = false; // Ensure the new section is visible
                        }
                    }, 0)
                        .to(currSection, {opacity: 0, duration: 0.25}, 0);
                }

                tl
                    .to(newSection, {opacity: 1, duration: 0.25}, 0.6)
                    .to(newSection, {y: '0', duration: 0.35, ease: 'power2.out'}, '-=0.25');

                // Update button visibility and state
                prevBtn.disabled = step === firstStep;
                prevBtn.setAttribute('aria-disabled', step === firstStep ? 'true' : 'false');
                nextBtn.style.display = (step === lastStep) ? 'none' : 'inline-block';
                submitBtn.style.display = (step === lastStep) ? 'inline-block' : 'none';
                submitBtn.parentElement.style.justifyContent = (step === lastStep) ? 'flex-start' : 'space-between';

                // Announce current section
                contactForm.setAttribute('aria-description', `Currently on section ${step} of ${lastStep}`);
            }

            let gotoNext = (e) => {
                e.preventDefault();
                if ('true' !== nextBtn.getAttribute('aria-busy')) {
                    if (validateCurrentSection()) {
                        if (currentSectionStep <= lastStep) {
                            currentSectionStep++;
                            while (!fetchByStep(currentSectionStep) && currentSectionStep <= lastStep) {
                                currentSectionStep++;
                            }
                            if (currentSectionStep <= lastStep) {
                                showSection(currentSectionStep);
                            }
                        }
                    }
                }
            }

            function validateCurrentSection() {
                let currentSection = contactForm.querySelector('.multisection-fw-form__step--active');
                const inputs = currentSection.querySelectorAll('input,select,textarea');
                let allValid = true;
                inputs.forEach(input => {
                    if (!input.reportValidity()) {
                        allValid = false;
                    }
                });
                return allValid;
            }

            function submitSuccess() {
                const thankYouSection = contactForm.querySelector('.multisection-fw-form__thank-you');
                const currSection = contactForm.querySelector('.multisection-fw-form__step--active');
                const formButtons = contactForm.querySelectorAll('.multisection-fw-form__form-buttons button');
                // Hide the sections
                gsap.set(thankYouSection, {y: '+=100', opacity: 0});

                const tl = gsap.timeline({
                    onComplete: () => {
                        currSection.classList.remove('multisection-fw-form__step--active');
                        contactForm.removeAttribute('aria-busy');
                        gsap.set(thankYouSection, {clearProps: 'all'}); // Clear all inline styles
                        thankYouSection.focus();
                    }
                });

                tl.to(formButtons, {yPercent: +100, duration: 0.38, ease: 'power2.inOut'}, 0)
                    .to(currSection, {
                        y: '+=100', duration: 0.5, ease: 'power2.inOut', onComplete: () => {
                            gsap.set(currSection, {clearProps: 'all'}); // Clear all inline styles
                            currSection.hidden = true;
                            thankYouSection.hidden = false;
                            thankYouSection.setAttribute('aria-hidden', 'false');
                            contactForm.removeAttribute('aria-description');
                        }
                    }, 0)
                    .to(currSection, {opacity: 0, duration: 0.25}, 0)
                    .to(thankYouSection, {opacity: 1, duration: 0.25}, 0.8)
                    .to(thankYouSection, {y: '0', duration: 0.5, ease: 'power2.out'}, '-=0.25');
            }

            function resetSubmit() {
                const thankYouSection = contactForm.querySelector('.multisection-fw-form__thank-you');
                thankYouSection.hidden = true;
                thankYouSection.setAttribute('aria-hidden', 'true');
                sections.forEach(section => gsap.set(section, { clearProps: 'all' }));
                gsap.set(thankYouSection, { clearProps: 'all' });
            }

            function showError(error) {
                let current = fetchByStep(currentSectionStep);
                let errorBlock = current.querySelector('.layout-form__error');
                if (errorBlock) {
                    // noinspection DuplicatedCode
                    errorBlock.innerHTML = '<p>' + error + '</p>';
                    gsap.set(errorBlock, {display: 'block', opacity: 0});
                    let eh = errorBlock.offsetHeight; // The height we will be expanding to
                    errorBlock.style.height = 0; // Set height to zero
                    errorBlock.setAttribute('aria-hidden', 'false');
                    errorBlock.removeAttribute('hidden');
                    errorBlock.classList.add('active');
                    gsap.to(errorBlock, {
                        height: eh,
                        opacity: 1,
                        duration: 0.6,
                        ease: 'power2.inOut',
                        onComplete: () => gsap.set(errorBlock, {clearProps: 'height'})
                    });
                }
            }

            function resetForm() {
                resetSubmit();
                contactForm.reset();
                resetSection();
                currentSectionStep = firstStep;
                showSection(firstStep);
            }

            if (prevBtn) {
                prevBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    if ('true' !== prevBtn.getAttribute('aria-busy')) {
                        if (currentSectionStep > firstStep) {
                            currentSectionStep--;
                            while (!fetchByStep(currentSectionStep) && currentSectionStep > firstStep) {
                                currentSectionStep--;
                            }
                            showSection(currentSectionStep);
                        }
                    }
                });
            }

            if (nextBtn) {
                nextBtn.addEventListener('click', gotoNext);
            }

            contactAvailabilityInputs.forEach((el) => {
                el.addEventListener('change', (e) => {
                    if (e.currentTarget.value === 'calendar') {
                        $('.chat-calendar').fadeIn();
                        e.currentTarget.setAttribute('aria-expanded', 'true');
                    } else {
                        $('.chat-calendar').fadeOut();
                        e.currentTarget.setAttribute('aria-expanded', 'false');
                    }
                });
            });

            if (noWebsiteInput) {
                noWebsiteInput.addEventListener('change', (e) => {
                    if (e.currentTarget.checked) {
                        websiteInput.removeAttribute('required');
                    } else {
                        websiteInput.setAttribute('required', 'required');
                    }
                });
            }

            let disableContactForm = () => {
                contactForm.setAttribute('aria-busy', 'true');
                prevBtn.setAttribute('aria-busy', 'true');
                nextBtn.setAttribute('aria-busy', 'true');
            }

            let enableContactForm = () => {
                contactForm.removeAttribute('aria-busy');
                prevBtn.removeAttribute('aria-busy');
                nextBtn.removeAttribute('aria-busy');
            }

            contactForm.addEventListener('submit', (e) => {
                e.preventDefault();
                if (!contactForm.hasAttribute('aria-busy')) {
                    if (validateCurrentSection()) {
                        let data = new FormData(contactForm);
                        disableContactForm();
                        submitBtn.dispatchEvent(new CustomEvent('start-loading'));
                        $.ajax({
                            url: params.ajax_url,
                            data: data,
                            contentType: false,
                            processData: false,
                            type: 'POST'
                        }).then(response => {
                            enableContactForm();
                            if ('success' === response.status) {
                                submitSuccess();
                            } else {
                                showError(response.error ?? 'Something went wrong. Please try again.');
                            }
                            submitBtn.dispatchEvent(new CustomEvent('stop-loading'));
                        });
                    } else {
                        enableContactForm();
                        alert('Please fill in all required fields in the current section.');
                    }
                }
            });

            let handleEnter = (event) => {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    gotoNext(event);
                }
            }

            document.addEventListener('opening-modal', (ev) => {
                if ('hire-us_modal' === ev.detail) {
                    document.addEventListener('keydown', handleEnter);
                    resetForm();
                }
            });

            document.addEventListener('closing-modal', (ev) => {
                if ('hire-us_modal' === ev.detail) {
                    document.removeEventListener('keydown', handleEnter);
                }
            });

        }
    }
});